import {
  ENGAGEMENT_STATUS_VARIANT,
  SPEAKER_STATUS_VARIANT,
  EVENT_STATUS_VARIANT,
} from '../../utils/constants.js';

const REVIEW_VARIANT = {
  pending:  'warning',
  approved: 'success',
  rejected: 'danger',
  returned: 'warning',
  none:     'neutral',
};

export function StatusBadge({ status, type = 'engagement' }) {
  const variantMap =
    type === 'engagement' ? ENGAGEMENT_STATUS_VARIANT
    : type === 'speaker'   ? SPEAKER_STATUS_VARIANT
    : type === 'event'     ? EVENT_STATUS_VARIANT
    : type === 'review'    ? REVIEW_VARIANT
    : {};

  const variant = variantMap[status] ?? 'neutral';
  return <span className={`badge badge-${variant}`}>{status}</span>;
}
